import Axios from '../lib/axios';

/**
 * Fetches the health and development bonus history with pagination
 * @param params Object containing page, limit, and all (boolean for admin to see all users' data)
 */
const GetHDBonusHistory = (params: { page: number; limit: number; all?: boolean }) => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/hdbonus`, { params });
};

/**
 * Submits a new health and development bonus entry
 * @param bonusData The bonus data containing participation flags and answers
 */
const SubmitHDBonus = (bonusData: any) => {
  return Axios.post(`${process.env.REACT_APP_SERVER_ROOT || ''}/hdbonus`, bonusData);
};

/**
 * Checks if current user has already submitted a bonus for the specified period
 * @param period The bonus period in YYYY-MM format (optional, defaults to current month)
 */
const CheckExistingSubmission = (period?: string) => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/hdbonus/check`, {
    params: { period },
  });
};

/**
 * Gets a specific bonus submission by ID
 * @param id The bonus submission ID
 */
const GetHDBonusById = (id: string) => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/hdbonus/${id}`);
};

/**
 * Updates an existing health and development bonus entry (for admins)
 * @param id The bonus ID to update
 * @param bonusData The updated bonus data
 */
const UpdateHDBonus = (id: string, bonusData: any) => {
  return Axios.put(`${process.env.REACT_APP_SERVER_ROOT || ''}/hdbonus/${id}`, bonusData);
};

/**
 * Deletes a health and development bonus entry (for admins)
 * @param id The bonus ID to delete
 */
const DeleteHDBonus = (id: string) => {
  return Axios.delete(`${process.env.REACT_APP_SERVER_ROOT || ''}/hdbonus/${id}`);
};

/**
 * Gets quarterly summary data for health and development bonuses
 * @param params Optional filtering parameters like year, quarter, and admin view option
 */
const GetQuarterlySummary = (params?: { year?: number; quarter?: number; all?: boolean }) => {
  return Axios.get(`${process.env.REACT_APP_SERVER_ROOT || ''}/hdbonus/quarterly`, { params });
};

const hdBonusService = {
  GetHDBonusHistory,
  SubmitHDBonus,
  CheckExistingSubmission,
  GetHDBonusById,
  UpdateHDBonus,
  DeleteHDBonus,
  GetQuarterlySummary,
};

export default hdBonusService;
